import React from "react";
import { Container, Button } from "reactstrap";
import Papa from "papaparse";
import * as XLSX from "xlsx/xlsx.mjs";
import ReactTable from "react-table";
import "react-table/react-table.css";

import ImportStep1FileUpload from "./ImportStep1FileUpload";
import ImportStep1Header from "./ImportStep1Header";
import ImportStep1UploadProgress from "./ImportStep1UploadProgress";

const ImportStep1 = ({
  step,
  file,
  onFileAdd,
  tableData,
  onTableDataAdd,
  onTableDataRemove,
  onStepChange,
}) => {
  const _handleAddFile = (_file) => {
    try {
      if (_file?.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
        _handleAddFileExcel(_file);
      } else {
        Papa.parse(_file, {
          header: true,
          dynamicTyping: true,
          complete: (parseFile) => {
            onFileAdd(_file);
            onTableDataAdd({
              data: parseFile?.data,
              columns: makeColumns(parseFile?.meta?.fields),
            });
          },
        });
      }
    } catch (error) {
      console.log("Error in Add File", error);
    }
  };

  const _handleAddFileExcel = (_file) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const parsedData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      const headers = parsedData[0];
      const rows = parsedData.slice(1).map((row) => {
        const rowData = {};
        headers.forEach((header, index) => {
          rowData[header] = row[index];
        });
        return rowData;
      });

      const parseFile = {
        data: rows,
        errors: [],
        meta: {
          aborted: false,
          cursor: _file.size,
          delimiter: ",",
          fields: headers,
          linebreak: "\n",
          truncated: false,
        },
      };

      onFileAdd(_file);
      onTableDataAdd({
        data: parseFile.data,
        columns: makeColumns(parseFile.meta.fields),
      });
    };

    reader.readAsArrayBuffer(_file);
  };

  const makeColumns = (rawColumns) => {
    const filteredColumns = rawColumns?.filter((column) => column && !column.startsWith("_"));
    return filteredColumns?.map((column) => {
      return { Header: column, accessor: column };
    });
  };

  if (step === 2) {
    return (
      <Container fluid className="px-md-5">
        <ImportStep1UploadProgress step={step} onRemoveFile={onTableDataRemove} />
      </Container>
    );
  }

  return (
    <Container fluid className="px-md-5">
      <ImportStep1Header />

      {!file ? (
        <ImportStep1FileUpload addFile={_handleAddFile} />
      ) : (
        <ImportStep1UploadProgress onRemoveFile={onTableDataRemove} />
      )}

      {tableData && file && (
        <div>
          <h6 className="fw-semibold">Preview of your file</h6>
          <ReactTable data={tableData?.data} columns={tableData?.columns} defaultPageSize={5} />

          <div className="py-3 d-flex justify-content-center align-items-center">
            <Button color="primary" onClick={() => onStepChange(2)}>
              <span style={{ fontSize: "15px", fontWeight: 500 }}>
                Confim your file
              </span>
            </Button>
          </div>
        </div>
      )}
    </Container>
  );
};

export default ImportStep1;
